import React, { Component } from 'react';

import {
    Container,
    Divider } from "semantic-ui-react";

import {
    withAuthenticator,
    Greetings,
    SignIn,
    ForgotPassword,
    ConfirmSignIn,
    RequireNewPassword,
    VerifyContact } from 'aws-amplify-react';

import Amplify from 'aws-amplify';
import awsconfig from './aws-exports';

import MainMenu from './components/MainMenu';
import Country from './components/Country';
import Fee from './components/Fee';
import Gallery from './components/Gallery';

import './App.css';

Amplify.configure(awsconfig);



class App extends Component {

    constructor() {
        super();
        this.state = {
            displayPanel: 'countries'

        }
    }

    menuSelected = (name) => this.setState({ displayPanel: name })

    render() {
        const Panel = (props) => {
            const toDisplay = props.name;
            if (toDisplay === 'countries') {
                return <Country />;
            } else if (toDisplay === 'gallery') {
                return <Gallery />;
            } else {
                return <Fee />;
            }
        }

        return (
            <Container>
                <Divider hidden />
                <MainMenu onSelected={this.menuSelected}/>
                <Panel name={this.state.displayPanel} />
            </Container>
        );
    }
}

export default withAuthenticator(App, false, [
    <Greetings />,
    <SignIn/>,
    <ConfirmSignIn/>,
    <VerifyContact/>,
    <ForgotPassword/>,
    <RequireNewPassword/>
]);
